/** @jsx jsx */
import { jsx } from 'theme-ui'
import * as React from "react"
import { graphql, Link } from 'gatsby';
import PostLink from '../../components/post-link';
import Seo from '../../components/seo';
import slugify from '../../utils/slugify';

const Categories = ({ data }) => {
  return (
    <React.Fragment>
      <Seo title="Categories" description="Test" />
      {
        data.allMdx.group.map(g => {
          return (
            <div key={g.fieldValue}>
              <Link to={`/categories/${slugify(g.fieldValue)}`} sx={{
                textDecoration: 'none',
                color: 'black',
                '&:hover': {
                  textDecoration: 'underline',
                }}}
              >
              <h1 sx={{ marginTop: 0 }}>{g.fieldValue}</h1></Link>
              <ul sx={{
                textDecoration: "none",
                listStyle: "none",
                margin: 0,
                padding: 0
              }}>
                {g.nodes.map(node => (
                  <li key={node.id} sx={{ textDecoration: "none", marginBottom: 30 }}>
                    <article key={node.id}>
                      <PostLink
                        key={node.id}
                        link={node.fields.categoriesPostPath}
                        title={node.frontmatter.title}
                        date={node.frontmatter.date}
                      />
                    </article>
                  </li>
                ))}
              </ul>
            </div>
          )
        })
      }
    </React.Fragment>
  )
}

export default Categories;

export const query = graphql`
  query {
    allMdx(
      sort: {fields: frontmatter___date, order: DESC}
      filter: {fileAbsolutePath: {regex: "content/posts/"}}
    ) {
      group(field: frontmatter___category) {
        fieldValue
        nodes {
          fields {
            categoriesPostPath
          }
          frontmatter {
            title
            date(formatString: "MMMM D, YYYY")
            category
          }
          id
          parent {
            ... on File {
              modifiedTime(formatString: "MMMM D, YYYY")
            }
          }
        }
      }
    }
  }
`;
